import React, { useState, Component } from 'react';
import { MenuIcon, XIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
const Navbar = () => {
  const [isOpen, setIsOpen] = useState(false);
  const navItems = [{
    name: 'Product',
    href: '#product'
  }, {
    name: 'Components',
    href: '#components'
  }, {
    name: 'Platform',
    href: '#platform'
  }, {
    name: 'Security',
    href: '#security'
  }, {
    name: 'Community',
    href: '/community',
    isRouterLink: true
  }, {
    name: 'Pricing',
    href: '#pricing'
  }];
  return <header className="w-full bg-white/80 backdrop-blur-md sticky top-0 z-50 border-b border-gray-100" data-id="element-787">
      <div className="container mx-auto px-4 sm:px-6 md:px-8 py-3 sm:py-4 flex justify-between items-center" data-id="element-788">
        <div className="flex items-center gap-2" data-id="element-789">
          <Link to="/" className="flex items-center group" data-id="element-790">
            <img src="https://cdn.magicpatterns.com/uploads/fMJnv7yQ9EawQ6b54Tnvxq/FWLogo.png" alt="FluidWeb Logo" className="h-7 sm:h-8 transition-opacity group-hover:opacity-80" data-id="element-791" />
          </Link>
        </div>

        {/* Desktop Navigation */}
        <nav className="hidden md:flex items-center space-x-6 lg:space-x-8" data-id="element-792">
          {navItems.map((item, index) => item.isRouterLink ? <Link key={index} to={item.href} className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-793">
                {item.name}
              </Link> : <a key={index} href={item.href} className="text-sm font-medium text-gray-600 hover:text-gray-900 transition-colors" data-id="element-794">
                {item.name}
              </a>)}

          <a href="https://cal.com/fluidn/30min" target="_blank" rel="noopener noreferrer" className="bg-gray-900 text-white px-4 lg:px-5 py-2 lg:py-2.5 rounded-full text-sm font-medium hover:bg-gray-800 transition-colors min-h-[44px] flex items-center whitespace-nowrap" data-id="element-795">
            Get a demo
          </a>
        </nav>

        {/* Mobile menu button */}
        <button className="md:hidden text-gray-700 p-2 min-h-[44px] min-w-[44px] flex items-center justify-center" onClick={() => setIsOpen(!isOpen)} aria-label="Toggle menu" data-id="element-796">
          {isOpen ? <XIcon size={24} data-id="element-797" /> : <MenuIcon size={24} data-id="element-798" />}
        </button>
      </div>

      {/* Mobile Navigation */}
      {isOpen && <div className="md:hidden bg-white border-b border-gray-100 absolute w-full left-0 top-full shadow-xl max-h-[calc(100vh-60px)] overflow-y-auto" data-id="element-799">
          <div className="container mx-auto px-4 py-4 flex flex-col space-y-1" data-id="element-800">
            {navItems.map((item, index) => item.isRouterLink ? <Link key={index} to={item.href} className="text-gray-700 py-3 hover:text-orange-500 hover:bg-orange-50 transition-colors font-medium rounded-lg px-3 min-h-[44px] flex items-center" onClick={() => setIsOpen(false)} data-id="element-801">
                  {item.name}
                </Link> : <a key={index} href={item.href} className="text-gray-700 py-3 hover:text-orange-500 hover:bg-orange-50 transition-colors font-medium rounded-lg px-3 min-h-[44px] flex items-center" onClick={() => setIsOpen(false)} data-id="element-802">
                  {item.name}
                </a>)}
            <div className="border-t border-gray-100 pt-4 mt-2" data-id="element-803">
              <a href="https://cal.com/fluidn/30min" target="_blank" rel="noopener noreferrer" className="bg-gray-900 text-white px-4 py-3 rounded-lg hover:bg-gray-800 transition-colors text-center font-medium block min-h-[44px] flex items-center justify-center" data-id="element-804">
                Get a demo
              </a>
            </div>
          </div>
        </div>}
    </header>;
};
export default Navbar;